import { Paper } from '@mui/material'
import React from 'react'

const PaperCommon = ({
    borderRadius,
    padding,
    contant,
    boxShadow
}) => {
    return (
        <>
            <Paper elevation={0} sx={{ borderRadius: borderRadius || "25px", padding: padding || { xs: "15px", md: "25px", lg: "25px" }, boxShadow:boxShadow }}>
                {contant}
            </Paper>
        </>
    )
}

export default PaperCommon
